import React from 'react';

function About() {
    return (
        <div className="about-terminal-grid">
            <div className="about-header">
                <h3>Jeremy Roy</h3>
                <div className="about-subtitle">Mechanical Engineer & Data Engineer</div>
            </div>

            <div className="terminal-line" style={{ color: '#94a3b8', fontStyle: 'italic', marginBottom: '0.5rem' }}>
                ➜ cat profile_bio.txt
            </div>

            <p className="about-bio" style={{ fontSize: '0.9rem', lineHeight: '1.6' }}>
                I am a qualified Mechanical Engineer and an experienced Data Engineer.
                I bridge the gap between physical engineering systems and advanced cloud analytics.
                Currently, I manage water utilities telemetry data visualised on GIS-based front ends,
                handling large scale data ingestion, spatial risk assessment, and dashboard analytics.
            </p>

            <div style={{ margin: '1rem 0', borderBottom: '1px dashed rgba(255, 255, 255, 0.1)' }}></div>

            <div className="terminal-line" style={{ color: '#94a3b8', fontStyle: 'italic', marginBottom: '0.5rem' }}>
                ➜ cat focus_areas.json
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', fontSize: '0.85rem' }}>
                <div>
                    <h4 style={{ color: '#38bdf8', marginBottom: '0.4rem', fontFamily: 'monospace' }}>[Data Engineering]</h4>
                    <ul style={{ listStyleType: 'none', color: '#94a3b8', paddingLeft: '0.25rem', lineHeight: '1.5' }}>
                        <li>• Telemetry Stream Ingestion</li>
                        <li>• Scalable ETL Workflows</li>
                        <li>• SQL & Spatial databases</li>
                        <li>• Automated pipelines (Databricks)</li>
                    </ul>
                </div>
                <div>
                    <h4 style={{ color: '#38bdf8', marginBottom: '0.4rem', fontFamily: 'monospace' }}>[GIS & Systems]</h4>
                    <ul style={{ listStyleType: 'none', color: '#94a3b8', paddingLeft: '0.25rem', lineHeight: '1.5' }}>
                        <li>• Interactive WebGIS frontends</li>
                        <li>• Leaflet & Mapbox API grids</li>
                        <li>• Hazard & Risk spatial indexing</li>
                        <li>• Mechanical Instrumentation</li>
                    </ul>
                </div>
            </div>

            <div style={{ margin: '1rem 0', borderBottom: '1px dashed rgba(255, 255, 255, 0.1)' }}></div>

            <div className="terminal-line" style={{ color: '#94a3b8', fontStyle: 'italic', marginBottom: '0.5rem' }}>
                ➜ cat core_skills.sh
            </div>

            <div className="skills-list">
                <span className="skill-tag">Python</span>
                <span className="skill-tag">SQL</span>
                <span className="skill-tag">PostGIS</span>
                <span className="skill-tag">React.js</span>
                <span className="skill-tag">Leaflet</span>
                <span className="skill-tag">Databricks</span>
                <span className="skill-tag">Linux</span>
                <span className="skill-tag">Docker</span>
                <span className="skill-tag">Hydraulics</span>
                <span className="skill-tag">SCADA Telemetry</span>
            </div>
        </div>
    );
}

export default About;
